import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useDropdownController } from '../../../internal/hooks/controllers';
import { useFocusGroupOptionController } from '../useFocusGroupOptionController';
export function useGroupedSelectDesktopController(props) {
  const {
    open,
    actions: dropdownActions
  } = useDropdownController(props);
  const {
    focusedIndex,
    actions: focusedOptionActions
  } = useFocusGroupOptionController({
    groups: props.groups
  });
  const stateRef = useValueRef({
    props,
    open,
    focusedIndex
  });
  React.useEffect(() => {
    const {
      groups,
      value
    } = stateRef.current.props;
    if (!open) {
      let selectedOptionIndex = 0;
      const selectedGroupIndex = groups.findIndex(group => {
        const optionIndex = group.options.findIndex(option => option.value === value);
        if (optionIndex === -1) {
          return false;
        }
        selectedOptionIndex = optionIndex;
        return true;
      });
      focusedOptionActions.setFocusedIndex({
        group: Math.max(selectedGroupIndex, 0),
        option: selectedOptionIndex
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  const selectOption = index => {
    const {
      props
    } = stateRef.current;
    const group = props.groups[index.group];
    if (!group) {
      return;
    }
    const option = group.options[index.option];
    const optionValue = option.value;
    const prevValue = props.value;
    if (optionValue !== prevValue) {
      props.onChange(optionValue);
    }
  };
  const selectFocusedOption = () => selectOption(stateRef.current.focusedIndex);
  const actions = _objectSpread(_objectSpread(_objectSpread({}, dropdownActions), focusedOptionActions), {}, {
    selectOption,
    selectFocusedOption
  });
  return {
    open,
    focusedIndex,
    actions
  };
}